'use client';

import React from 'react';
import dynamic from 'next/dynamic';

import { Container } from '@/components/Container';
import { FullArticle } from '@/components/FullArticle/FullArticle';
import { BlogLayout } from '@/components/Layouts/BlogLayout';
import Section from '@/components/Section/Section';
import { BookDemo } from '@/features/BookDemo/BookDemo';
import { FeaturesIntro } from '@/features/FeaturesIntro/FeaturesIntro';
import { WorkFlowV2 } from '@/features/WorkFlow/WorkFlowV2';
import {
  blog,
  bookDemo,
  fullArticle2,
  intro,
} from '@/lib/features/payment_management';

const BlogDynamic = dynamic(() => import('@/features/Blog/Blog'), {
  ssr: false,
});

const SalesProposal = () => {
  return (
    <>
      <FeaturesIntro {...intro} />

      <WorkFlowV2 />

      <Section>
        <Container>
          <FullArticle revert={true} item={fullArticle2} />
        </Container>
      </Section>

      <BlogLayout>
        <Container>
          <Section title={blog.title} description={blog.description}>
            <BlogDynamic />
          </Section>
        </Container>
      </BlogLayout>

      <BookDemo {...bookDemo} />
    </>
  );
};

export default SalesProposal;
